/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
import * as Types from "../../../../__graphql__/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type ActivityStatusChangedInput = {
  activityType: ActivityType;
  trigger: ActivityTrigger;
};

/** Whether the activity is starting or ending */
export type ActivityTrigger = "END" | "START";

/** The type of activity being tracked */
export type ActivityType =
  | "BREAK"
  | "DELIVERY_CHECK_IN"
  | "INBOUNDING"
  | "INVENTORY_CHECKS"
  | "PICKING"
  | "RESCUE_BAG"
  | "RESTOCKING";

export type DeliveryCheckinProductCategory = "DRINKS" | "DRY" | "FRESH" | "FROZEN";

export type DeliveryRolliV2 = {
  desadvId?: string | null | undefined;
  expectedHubSlug?: string | null | undefined;
  sscc: string;
  status: string;
};

export type NewDeliveryCheckinInputV2 = {
  deliveredAt: string;
  deliveryRollies?: Array<DeliveryRolliV2> | null | undefined;
  supplierId: string;
};

export type GetDeliveryCheckInsForHubDeliveredTodayQueryVariables = Exact<{ [key: string]: never }>;

export type GetDeliveryCheckInsForHubDeliveredTodayQuery = {
  getDeliveryCheckInsForHubDeliveredToday: {
    deliveryCheckins: Array<{
      categories: Array<Types.DeliveryCheckinProductCategory> | null;
      delivered_at: string;
      id: string;
      supplier: { id: string; name: string };
    }>;
  };
};

export type GetDeliveryCheckInsForHubDeliveredTodayV2QueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetDeliveryCheckInsForHubDeliveredTodayV2Query = {
  getDeliveryCheckInsForHubDeliveredTodayV2: {
    deliveryCheckins: Array<{
      deliveredAt: string;
      id: string;
      numberOfAcceptedRollies: number;
      supplier: { id: string; name: string };
    }>;
  };
};

export type CreateDeliveryCheckinForHubV2MutationVariables = Exact<{
  input: Types.NewDeliveryCheckinInputV2;
}>;

export type CreateDeliveryCheckinForHubV2Mutation = {
  createDeliveryCheckinForHubV2: { deliveryCheckin: { id: string } };
};

export type PublishActivityStatusChangedMutationVariables = Exact<{
  input: Types.ActivityStatusChangedInput;
}>;

export type PublishActivityStatusChangedMutation = {
  publishActivityStatusChanged: { success: boolean };
};

export const GetDeliveryCheckInsForHubDeliveredTodayDocument = gql`
  query getDeliveryCheckInsForHubDeliveredToday {
    getDeliveryCheckInsForHubDeliveredToday {
      deliveryCheckins {
        categories
        delivered_at
        id
        supplier {
          id
          name
        }
      }
    }
  }
`;

/**
 * __useGetDeliveryCheckInsForHubDeliveredTodayQuery__
 *
 * To run a query within a React component, call `useGetDeliveryCheckInsForHubDeliveredTodayQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeliveryCheckInsForHubDeliveredTodayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeliveryCheckInsForHubDeliveredTodayQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDeliveryCheckInsForHubDeliveredTodayQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetDeliveryCheckInsForHubDeliveredTodayQuery,
    GetDeliveryCheckInsForHubDeliveredTodayQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDeliveryCheckInsForHubDeliveredTodayQuery,
    GetDeliveryCheckInsForHubDeliveredTodayQueryVariables
  >(GetDeliveryCheckInsForHubDeliveredTodayDocument, options);
}
export function useGetDeliveryCheckInsForHubDeliveredTodayLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDeliveryCheckInsForHubDeliveredTodayQuery,
    GetDeliveryCheckInsForHubDeliveredTodayQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDeliveryCheckInsForHubDeliveredTodayQuery,
    GetDeliveryCheckInsForHubDeliveredTodayQueryVariables
  >(GetDeliveryCheckInsForHubDeliveredTodayDocument, options);
}
// @ts-ignore
export function useGetDeliveryCheckInsForHubDeliveredTodaySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetDeliveryCheckInsForHubDeliveredTodayQuery,
    GetDeliveryCheckInsForHubDeliveredTodayQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetDeliveryCheckInsForHubDeliveredTodayQuery,
  GetDeliveryCheckInsForHubDeliveredTodayQueryVariables
>;
export function useGetDeliveryCheckInsForHubDeliveredTodaySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDeliveryCheckInsForHubDeliveredTodayQuery,
        GetDeliveryCheckInsForHubDeliveredTodayQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetDeliveryCheckInsForHubDeliveredTodayQuery | undefined,
  GetDeliveryCheckInsForHubDeliveredTodayQueryVariables
>;
export function useGetDeliveryCheckInsForHubDeliveredTodaySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDeliveryCheckInsForHubDeliveredTodayQuery,
        GetDeliveryCheckInsForHubDeliveredTodayQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetDeliveryCheckInsForHubDeliveredTodayQuery,
    GetDeliveryCheckInsForHubDeliveredTodayQueryVariables
  >(GetDeliveryCheckInsForHubDeliveredTodayDocument, options);
}
export type GetDeliveryCheckInsForHubDeliveredTodayQueryHookResult = ReturnType<
  typeof useGetDeliveryCheckInsForHubDeliveredTodayQuery
>;
export type GetDeliveryCheckInsForHubDeliveredTodayLazyQueryHookResult = ReturnType<
  typeof useGetDeliveryCheckInsForHubDeliveredTodayLazyQuery
>;
export type GetDeliveryCheckInsForHubDeliveredTodaySuspenseQueryHookResult = ReturnType<
  typeof useGetDeliveryCheckInsForHubDeliveredTodaySuspenseQuery
>;
export type GetDeliveryCheckInsForHubDeliveredTodayQueryResult = Apollo.QueryResult<
  GetDeliveryCheckInsForHubDeliveredTodayQuery,
  GetDeliveryCheckInsForHubDeliveredTodayQueryVariables
>;
export const GetDeliveryCheckInsForHubDeliveredTodayV2Document = gql`
  query getDeliveryCheckInsForHubDeliveredTodayV2 {
    getDeliveryCheckInsForHubDeliveredTodayV2 {
      deliveryCheckins {
        deliveredAt
        id
        supplier {
          id
          name
        }
        numberOfAcceptedRollies
      }
    }
  }
`;

/**
 * __useGetDeliveryCheckInsForHubDeliveredTodayV2Query__
 *
 * To run a query within a React component, call `useGetDeliveryCheckInsForHubDeliveredTodayV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetDeliveryCheckInsForHubDeliveredTodayV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeliveryCheckInsForHubDeliveredTodayV2Query({
 *   variables: {
 *   },
 * });
 */
export function useGetDeliveryCheckInsForHubDeliveredTodayV2Query(
  baseOptions?: Apollo.QueryHookOptions<
    GetDeliveryCheckInsForHubDeliveredTodayV2Query,
    GetDeliveryCheckInsForHubDeliveredTodayV2QueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDeliveryCheckInsForHubDeliveredTodayV2Query,
    GetDeliveryCheckInsForHubDeliveredTodayV2QueryVariables
  >(GetDeliveryCheckInsForHubDeliveredTodayV2Document, options);
}
export function useGetDeliveryCheckInsForHubDeliveredTodayV2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDeliveryCheckInsForHubDeliveredTodayV2Query,
    GetDeliveryCheckInsForHubDeliveredTodayV2QueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDeliveryCheckInsForHubDeliveredTodayV2Query,
    GetDeliveryCheckInsForHubDeliveredTodayV2QueryVariables
  >(GetDeliveryCheckInsForHubDeliveredTodayV2Document, options);
}
// @ts-ignore
export function useGetDeliveryCheckInsForHubDeliveredTodayV2SuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetDeliveryCheckInsForHubDeliveredTodayV2Query,
    GetDeliveryCheckInsForHubDeliveredTodayV2QueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetDeliveryCheckInsForHubDeliveredTodayV2Query,
  GetDeliveryCheckInsForHubDeliveredTodayV2QueryVariables
>;
export function useGetDeliveryCheckInsForHubDeliveredTodayV2SuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDeliveryCheckInsForHubDeliveredTodayV2Query,
        GetDeliveryCheckInsForHubDeliveredTodayV2QueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetDeliveryCheckInsForHubDeliveredTodayV2Query | undefined,
  GetDeliveryCheckInsForHubDeliveredTodayV2QueryVariables
>;
export function useGetDeliveryCheckInsForHubDeliveredTodayV2SuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDeliveryCheckInsForHubDeliveredTodayV2Query,
        GetDeliveryCheckInsForHubDeliveredTodayV2QueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetDeliveryCheckInsForHubDeliveredTodayV2Query,
    GetDeliveryCheckInsForHubDeliveredTodayV2QueryVariables
  >(GetDeliveryCheckInsForHubDeliveredTodayV2Document, options);
}
export type GetDeliveryCheckInsForHubDeliveredTodayV2QueryHookResult = ReturnType<
  typeof useGetDeliveryCheckInsForHubDeliveredTodayV2Query
>;
export type GetDeliveryCheckInsForHubDeliveredTodayV2LazyQueryHookResult = ReturnType<
  typeof useGetDeliveryCheckInsForHubDeliveredTodayV2LazyQuery
>;
export type GetDeliveryCheckInsForHubDeliveredTodayV2SuspenseQueryHookResult = ReturnType<
  typeof useGetDeliveryCheckInsForHubDeliveredTodayV2SuspenseQuery
>;
export type GetDeliveryCheckInsForHubDeliveredTodayV2QueryResult = Apollo.QueryResult<
  GetDeliveryCheckInsForHubDeliveredTodayV2Query,
  GetDeliveryCheckInsForHubDeliveredTodayV2QueryVariables
>;
export const CreateDeliveryCheckinForHubV2Document = gql`
  mutation createDeliveryCheckinForHubV2($input: NewDeliveryCheckinInputV2!) {
    createDeliveryCheckinForHubV2(input: $input) {
      deliveryCheckin {
        id
      }
    }
  }
`;
export type CreateDeliveryCheckinForHubV2MutationFn = Apollo.MutationFunction<
  CreateDeliveryCheckinForHubV2Mutation,
  CreateDeliveryCheckinForHubV2MutationVariables
>;

/**
 * __useCreateDeliveryCheckinForHubV2Mutation__
 *
 * To run a mutation, you first call `useCreateDeliveryCheckinForHubV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDeliveryCheckinForHubV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDeliveryCheckinForHubV2Mutation, { data, loading, error }] = useCreateDeliveryCheckinForHubV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDeliveryCheckinForHubV2Mutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateDeliveryCheckinForHubV2Mutation,
    CreateDeliveryCheckinForHubV2MutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateDeliveryCheckinForHubV2Mutation,
    CreateDeliveryCheckinForHubV2MutationVariables
  >(CreateDeliveryCheckinForHubV2Document, options);
}
export type CreateDeliveryCheckinForHubV2MutationHookResult = ReturnType<
  typeof useCreateDeliveryCheckinForHubV2Mutation
>;
export type CreateDeliveryCheckinForHubV2MutationResult =
  Apollo.MutationResult<CreateDeliveryCheckinForHubV2Mutation>;
export type CreateDeliveryCheckinForHubV2MutationOptions = Apollo.BaseMutationOptions<
  CreateDeliveryCheckinForHubV2Mutation,
  CreateDeliveryCheckinForHubV2MutationVariables
>;
export const PublishActivityStatusChangedDocument = gql`
  mutation publishActivityStatusChanged($input: ActivityStatusChangedInput!) {
    publishActivityStatusChanged(input: $input) {
      success
    }
  }
`;
export type PublishActivityStatusChangedMutationFn = Apollo.MutationFunction<
  PublishActivityStatusChangedMutation,
  PublishActivityStatusChangedMutationVariables
>;

/**
 * __usePublishActivityStatusChangedMutation__
 *
 * To run a mutation, you first call `usePublishActivityStatusChangedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishActivityStatusChangedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishActivityStatusChangedMutation, { data, loading, error }] = usePublishActivityStatusChangedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublishActivityStatusChangedMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PublishActivityStatusChangedMutation,
    PublishActivityStatusChangedMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PublishActivityStatusChangedMutation,
    PublishActivityStatusChangedMutationVariables
  >(PublishActivityStatusChangedDocument, options);
}
export type PublishActivityStatusChangedMutationHookResult = ReturnType<
  typeof usePublishActivityStatusChangedMutation
>;
export type PublishActivityStatusChangedMutationResult =
  Apollo.MutationResult<PublishActivityStatusChangedMutation>;
export type PublishActivityStatusChangedMutationOptions = Apollo.BaseMutationOptions<
  PublishActivityStatusChangedMutation,
  PublishActivityStatusChangedMutationVariables
>;
